(ns iris.routes
  (:require
   [bidi.bidi :as bidi]
   [pushy.core :as pushy]
   [re-frame.core :as re-frame]
   [iris.events :as events]
   [cemerick.url :as cemerick.url]
   [clerk.core :as clerk]))

(defmulti panels identity)
(defmethod panels :default [] [:div "No panel found for this route."])

(defn mirror-hrefs [handler route-params anchor-params]
  (case handler
    (:logs :posts)
      {:posts-href "/posts" :logs-href "/logs" :mirrored? true}
    :thread
      (if (re-matches #"[a-zA-Z0-9]{2,5}" (or anchor-params ""))
        {:posts-href (str "/t/" (:id route-params) "#" anchor-params)
         :logs-href  (str "/logs/p/@" anchor-params "+" (:id route-params))
         :mirrored?  true}
        {:posts-href (str "/t/" (:id route-params))
         :logs-href  (str "/logs/t/" (:id route-params))
         :mirrored?  true})
    :logs-thread
      {:posts-href (str "/t/" (:id route-params))
       :logs-href  (str "/logs/t/" (:id route-params))
       :mirrored?  true}
    :logs-post
      (let [id        (:id route-params)
            plus-idx  (.indexOf id "+")
            nick      (subs id 1 plus-idx)
            thread-id (subs id (inc plus-idx))]
        {:posts-href (str "/t/" thread-id "#" nick)
         :logs-href  (str "/logs/p/" id)
         :mirrored?  true})
    (:posts-ip :logs-ip)
      {:posts-href (str "/ip/" (:ip route-params))
       :logs-href  (str "/logs/ip/" (:ip route-params))
       :mirrored?  true}
    (:posts-eid :logs-eid)
      {:posts-href (str "/eid/" (:eid route-params))
       :logs-href  (str "/logs/eid/" (:eid route-params))
       :mirrored?  true}
    (:user :logs-user)
      {:posts-href (str "/user/" (:user route-params))
       :logs-href  (str "/logs/user/" (:user route-params))
       :mirrored?  true}
    (:posts-header :logs-header)
      {:posts-href (str "/" (:header route-params))
       :logs-href  (str "/logs/" (:header route-params))
       :mirrored?  true}
    {:posts-href "/posts" :logs-href "/logs" :mirrored? false}))

(def routes
  (atom
   ["/"
    {"" :homepage
     "login" {"" :login}
     "twbot" {"" :twbot}
     "tags" {"" :tags
             "/pending" :tags-pending
             "/approved" :tags-approved
             "/removed" :tags-removed
             "/blocked" :tags-blocked}
     "analytics" {"" :analytics
                  "/page-views" :analytics-page-views}
     "sessions" {"" :sessions}
     "logs" [["" :logs]
             ["/search" :logs-search]
             ["/header" [["/create" :logs-header-create]
                         [["/" [#".+" :chosen-header] "/create"] :logs-chosen-header-create]
                         [["/" [#".+" :chosen-header] "/edit"] :logs-chosen-header-edit]]]
             [["/p/" [#".+" :id]] :logs-post]
             [["/t/" [#".+" :id]] :logs-thread]
             [["/ip/" [#".+" :ip]] :logs-ip]
             [["/eid/" [#".+" :eid]] :logs-eid]
             [["/user/" [#".+" :user]] :logs-user]
             [["/" [#".+" :header]] :logs-header]]
     "dev" {"" :dev}
     "search" {"" :search}
     "screening" {""      :screens
                  "/create-new" :screens-create-new
                  ["/" :id] :screens-edit}
     "censoring" {"" :censors
                  "/create-new" :censors-create-new
                  ["/" :id] :censors-edit}
     "posts" {"" :posts}
     "last-25.php" {"" :latest}
     "user" {["/" [#".+" :user]] :user}
     "h" {["/" [#".+" :tag]] :hashtag}
     "t" {["/" :id] :thread}
     "cc" {["/" :cc] :posts-cc}
     "ip" {["/" [#".+" :ip]] :posts-ip}
     "eid" {["/" [#".+" :eid]] :posts-eid}
    ;;  [[#"^(?:s/|c/)?[a-zA-Z0-9-]+.[A-Z]{3}$" :header]] :posts-header
     [[#"^(?:(?!login(?:/|$)|homepage(?:/|$)|twbot(?:/|$)|tags(?:/|$)|analytics(?:/|$)|sessions(?:/|$)|dev(?:/|$)|search(?:/|$)|screening(?:/|$)|censoring(?:/|$)|posts(?:/|$)|latest(?:/|$)|logs(?:/|$)|user/|h/|t/|cc/|ip/|eid/).+)$" :header]] :posts-header
     }]))

;; NOTE: TSC header has /s/ and /c/ in front of it - /s/some-store.TSC /c/some-co.TSC
;; current header regex grabs both

;; :header regex note: bidi adds some extra regex to make it safe,
;; so the solution was to add an extra pair of brackets around it
;; with an empty string to avoid the problem, explained here:
;; https://github.com/juxt/bidi/issues/141

;; colons or spaces in slug won't be matched by bidi, e.g.: /eid/c:abcdef
;; workaround is to use [#".+" :eid] instead of bare :eid
;; here is the explanation:
;; https://github.com/juxt/bidi/issues/147#issuecomment-273367757


    ;;  ["/cc/" :cc] :posts-cc
    ;;  ["/ip/" :ip] :posts-ip
    ;;  ["/eid/" :eid] :posts-eid



;; https://github.com/juxt/bidi/issues/51#issuecomment-344101759
(defn match-route-with-query-params
  [route path & {:as options}]
  (let [query-params (->> (:query (cemerick.url/url path))
                          (map (fn [[k v]] [(keyword k) v]))
                          (into {}))
        anchor-params (:anchor (cemerick.url/url path))
        complete-url (.. js/document -location -href)]

    ;; (if-let [bm (get-in (cemerick.url/url path) [:query "bm"])]
    ;;   (do
    ;;     (println "NAVIGATIONG WITH #POSTS BECAUSE OF BM:" bm)
    ;;     (clerk/navigate-page! (str complete-url "#posts")))
    ;;   (do
    ;;     (println "NAVIGATING TO complete-url:" complete-url)
    ;;     (clerk/navigate-page! complete-url)))

(clerk/navigate-page! complete-url)

    (-> (bidi/match-route* route path options)
        (assoc :query-params query-params)
        (assoc :anchor-params anchor-params))))


;; bidi/match-route turns a URL into a data structure representing it
;; https://pablofernandez.tech/2015/08/26/no-hashes-bidirectional-routing-in-re-frame-with-bidi-and-pushy/
;; https://github.com/juxt/bidi/issues/51
(defn parse
  [url]
  ;; (bidi/match-route @routes url)
  (match-route-with-query-params @routes url))

;; point of using bidi was to not hard-code the URLs, for that I added this function
(defn url-for
  [& args]
  (apply bidi/path-for (into [@routes] args)))

;; (defn dispatch
;;   [route]
;;   (let [panel (keyword (str (name (:handler route)) "-panel"))]
;;     (re-frame/dispatch [::events/set-active-panel panel])))


;; Then dispatch-route is called with that structure:
(defn dispatch
  [route]
  (let [panel (keyword (str (name (:handler route)) "-panel"))]
    #_(re-frame/dispatch [::events/set-active-panel panel])
    (re-frame/dispatch [::events/set-route {:route route :panel panel}])))

(defonce history
  (pushy/pushy dispatch parse))

(defn navigate!
  [handler]
  (pushy/set-token! history (url-for handler)))

(defn start!
  []
  (pushy/start! history))

(re-frame/reg-fx
 :navigate
 (fn [handler]
   (navigate! handler)))

;; added on 06/02/2022
;; redirects to path ex. "/new/t/1h2IlohR"
;; to get path for thread handler use (routes/url-for :thread :id "1h2IlohR#OP")
(defn route-to! [route-str]
  (pushy/set-token! history route-str))

;; added on 06/18/2025
(defn route-to-replace! [route-str]
  (pushy/replace-token! history route-str))


(re-frame/reg-fx
 :route-to
 (fn [route-str]
   (route-to! route-str)))

;; added on 06/18/2025
(re-frame/reg-fx
 :route-to-replace
 (fn [route-str]
   (route-to-replace! route-str)))

;; added on 06/18/2025
;; | Method           | What it does                            | Back button behavior        |
;; | ---------------- | --------------------------------------- | --------------------------- |
;; | `set-token! `    | Pushes a new URL to the browser history | Back goes to previous route |
;; | `replace-token! `| Replaces current URL in history         | Back skips this change      |

;; ;; Go to /about and add it to history
;; (pushy/set-token! history "/about")

;; ;; Replace current URL with /about (no history entry added)
;; (pushy/replace-token! history "/about")


;; Under the hood
;; Internally, pushy wraps Google Closure's Html5History object, which uses:

;; history.pushState(state, title, url);
;; history.replaceState(state, title, url);

;; when setToken() or replaceToken() are called.